(function () {
  const COLOR_OPTION_NAMES = ['color', 'colour', 'couleur'];

  function parseMatchList(raw) {
    if (!raw || !raw.trim()) {
      return null;
    }

    return raw
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function getSelectedColor(root) {
    const activeWrapper = root.querySelector('.options-color-wrapper.active');

    if (activeWrapper) {
      const activeItem = activeWrapper.querySelector('.option-item[data-value]');

      if (activeItem) {
        return activeItem.getAttribute('data-value') || '';
      }
    }

    const checkedInputs = root.querySelectorAll('input.single-option-selector__radio:checked');

    for (const input of checkedInputs) {
      const optionName = input.getAttribute('name') || '';
      const optionIndex = optionName.replace('option', '');

      if (!optionIndex) {
        continue;
      }

      const fieldset = input.closest('fieldset');
      const legend = fieldset ? fieldset.querySelector('legend') : null;
      const legendText = legend ? legend.textContent.trim().toLowerCase() : '';

      if (COLOR_OPTION_NAMES.includes(legendText)) {
        return input.value || '';
      }
    }

    const firstChecked = root.querySelector('input.single-option-selector__radio:checked');

    return firstChecked ? firstChecked.value || '' : '';
  }

  function shouldShowBenefit(matchList, selectedColor) {
    if (!matchList) {
      return true;
    }

    return matchList.includes(selectedColor);
  }

  function updateBenefitVisibility(root) {
    const selectedColor = getSelectedColor(root);
    const benefits = root.querySelectorAll('.benefit-wrapper.buy-x-get-y');

    benefits.forEach((benefit) => {
      const matchRaw = benefit.getAttribute('data-variant-match') || '';
      const matchList = parseMatchList(matchRaw);
      const show = shouldShowBenefit(matchList, selectedColor);

      benefit.classList.toggle('is-variant-hidden', !show);
    });
  }

  function initRoot(root) {
    updateBenefitVisibility(root);

    root.addEventListener('click', (event) => {
      if (event.target.closest('.options-color-wrapper')) {
        window.requestAnimationFrame(() => {
          updateBenefitVisibility(root);
        });
      }
    });

    const formItem = root.querySelector('.product-form__item');

    if (formItem) {
      const observer = new MutationObserver(() => {
        updateBenefitVisibility(root);
      });

      observer.observe(formItem, { childList: true, subtree: true, attributes: true });
    }
  }

  function init() {
    document.querySelectorAll('.product_template_new').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
